module.exports = __webpack_public_path__ + "img/Feature.029df53b.jpg";